import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { CredentialsService } from '../core/credentials.service';
import { PatientToken, EntityCreatedResponse, UpdatePatientToken } from '../models';

@Injectable({ providedIn: 'root' })
export class PatientTokensService {

  constructor(private http: HttpClient, private credentialsService: CredentialsService, @Inject('BASE_URL') private baseUrl: string) {}

  create(body: PatientToken, ): Observable<EntityCreatedResponse> {
    const headers = new HttpHeaders({ 'Authorization': 'Bearer ' + this.credentialsService.getAccessToken() });
    return this.http.post<EntityCreatedResponse>(`${this.baseUrl}/v2/patientTokens`, body, { headers,  });
  }

  findAll(query: {where?: any; limit?: number; skip?: number; order?: string}): Observable<PatientToken[]> {
    const headers = new HttpHeaders({ 'Authorization': 'Bearer ' + this.credentialsService.getAccessToken() });
    if (query) {
      for (const key in query) {
        query[key] = JSON.stringify(query[key]);
      }
    }
    return this.http.get<PatientToken[]>(`${this.baseUrl}/v2/patientTokens`, { headers, params: <any>query });
  }

  findById(id: string, ): Observable<PatientToken> {
    const headers = new HttpHeaders({ 'Authorization': 'Bearer ' + this.credentialsService.getAccessToken() });
    return this.http.get<PatientToken>(`${this.baseUrl}/v2/patientTokens/${id}`, { headers,  });
  }

  replaceById(id: string, body: UpdatePatientToken, ): Observable<any> {
    const headers = new HttpHeaders({ 'Authorization': 'Bearer ' + this.credentialsService.getAccessToken() });
    return this.http.put<any>(`${this.baseUrl}/v2/patientTokens/${id}`, body, { headers,  });
  }

  updateById(id: string, body: PatientToken, ): Observable<any> {
    const headers = new HttpHeaders({ 'Authorization': 'Bearer ' + this.credentialsService.getAccessToken() });
    return this.http.patch<any>(`${this.baseUrl}/v2/patientTokens/${id}`, body, { headers,  });
  }

  deleteById(id: string, ): Observable<any> {
    const headers = new HttpHeaders({ 'Authorization': 'Bearer ' + this.credentialsService.getAccessToken() });
    return this.http.delete<any>(`${this.baseUrl}/v2/patientTokens/${id}`, { headers,  });
  }

}
